import { AxDropdown } from "@axess/limestone";
import { AxDatePicker, Cell, Mode } from "../../../Components/AxDatepicker/AxDatepicker";
import { InitData, TicketList } from "../../../Components/ProductList/TicketList";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { SummaryRedirect } from "../../../Lib/Helper/AxProdSelection/SummaryRedirect";
import { I18nHelper, Translations } from "../../../Lib/Helper/I18nHelper";
import { ProgressBar, ProgressBarMode } from "../../Global/Progressbar";
import { CheckMinMaxConstraintResult, PackageMinMaxConstraint } from "../../Packages/PackageMinMaxConstraint";

export abstract class PreDateable {
    protected ActivateDate: moment.Moment;
    protected QuantityOK: boolean;

    protected PostURL: string;
    protected CheckDateURL: string;
    protected DatePicker: AxDatePicker;
    protected DatePickerMobile: AxDatePicker;
    protected DatePattern: string;

    protected DateDropdown: AxDropdown = new AxDropdown();
    protected AvailableDateList: DateList[] = [];

    protected ContingentMode: boolean = false;

    private ShowPriceInCalendar: boolean = false;
    private CultureInfo: any;

    constructor(protected _summaryRedirect = new SummaryRedirect(),
        protected _Progressbar = new ProgressBar(),
        protected _TicketList = new TicketList(),
        protected _I18nHelper = new I18nHelper()
    ) { }

    Init(initData: AxProdInitData) {
        this.PostURL = initData.PostURL;
        this.CheckDateURL = initData.CheckDateLink;

        this.DatePattern = initData.DatePatternYear;
        this.CultureInfo = initData.CultureInfo;

        this._Progressbar.Init({
            Mode: ProgressBarMode.Default,
            Progress: 0
        });

        this.DatePicker = new AxDatePicker();
        this.DatePickerMobile = new AxDatePicker();

        this.DateDropdown.init('.prod_selection__date-selection .ax-dropdown');
        let endDate = initData.EndDate ? moment(initData.EndDate, "YYYY-MM-DD") : null;
        const blockedDates = initData?.closedDays?.map(x => moment(x, "YYYY-MM-DD"));

        this.DatePicker.Init({
            StartOfWeek: initData.StartOfWeek,
            Lang: initData.Lang,
            StartDate: moment(initData.StartDate, "YYYY-MM-DD"),
            DayRange: initData.DayRange,
            Target: '#tariff_date',
            Mode: Mode.Inline,
            EndDate: endDate,
            BlockedDates: blockedDates,
            OnChange: (x, y) => { return this.OnChangeDate(x, y) }
        });

        this.DatePickerMobile.Init({
            StartOfWeek: initData.StartOfWeek,
            Lang: initData.Lang,
            StartDate: moment(initData.StartDate, "YYYY-MM-DD"),
            DayRange: initData.DayRange,
            Target: '#tariff_date_mobile',
            Mode: Mode.Endless,
            LegendTarget: '#tariff_date_mobile__legend',
            EndDate: endDate,
            BlockedDates: blockedDates,
            OnChange: (x, y) => { return this.OnChangeDate(x, y) }
        });

        this._TicketList.Init(initData);

        this.DatePicker.ActivationSubject.subscribe(x => this.CheckDate(x));
        this.DatePickerMobile.ActivationSubject.subscribe(x => this.CheckDate(x));

        this._TicketList.QuantityOkSubject.subscribe(x => {
            this.QuantityOK = x;
            this.CheckSubmit();

        });

        this._TicketList.QuantityChange.subscribe(x => {
            if (this.ContingentMode) {
                for (let tmp of this.AvailableDateList) {
                    let date = moment(tmp.Date, 'YYYY-MM-DD');
                    if (tmp.Contingent && tmp.Available >= x) {
                        this.DatePicker.UnblockDate(date);
                        this.DatePickerMobile.UnblockDate(date);
                    } else {
                        this.DatePicker.BlockDate(date);
                        this.DatePickerMobile.BlockDate(date);
                    }
                }
            }

            this.UpdateCalendarText(this.AvailableDateList);
        });


        this.QuantityOK = this._TicketList.QuantityOkSubject.getValue();

        $('.prod_selection__prod-save').click(x => {
            $('.prod_selection__prod-close').click();
        });
    }

    OnChangeDate(startDate: moment.Moment, endDate: moment.Moment): Promise<void> {
        return new Promise<void>((res, rej) => {
            AxessViewer.loadPartialView(this.CheckDateURL, {
                from: startDate.format('YYYY-MM-DD'),
                to: endDate.format('YYYY-MM-DD')
            }, (z: DateList[]) => {

                let availableDates: moment.Moment[] = [];
                this.ContingentMode = this.ContingentMode || z.filter(x => x.Contingent).length != 0;

                for (let tmpDate of z) {
                    if (!this.ContingentMode || tmpDate.Contingent) {
                        let date = moment(tmpDate.Date, 'YYYY-MM-DD');
                        availableDates.push(date);
                    }
                }

                for (let dateEntry of z) {
                    if (this.AvailableDateList.find(x => x.Date == dateEntry.Date) == null) {
                        this.AvailableDateList.push(dateEntry);
                    }
                }

                this.UpdateCalendarText(z);

                this.DatePicker.Options.AvailableDates = availableDates;
                this.DatePickerMobile.Options.AvailableDates = availableDates;
                res();
            }, { silent: true, addCulturInfo: false });
        });
    }

    UpdateCalendarText(dateList: DateList[]) {
        let lastPriceList: PriceList[] = [];

        if (!this.ShowPriceInCalendar) {
            for (let tmpDate of dateList) {
                for (let priceEntry of tmpDate.TariffList) {
                    if (lastPriceList.find(x => x.SubProductIdentifier == priceEntry.SubProductIdentifier) == null) {
                        lastPriceList.push(priceEntry);
                        continue;
                    }

                    let compareEntry = lastPriceList.find(x => x.SubProductIdentifier == priceEntry.SubProductIdentifier);
                    if (compareEntry.Price != priceEntry.Price) {
                        this.ShowPriceInCalendar = true;
                        break;
                    }
                }

                if (this.ShowPriceInCalendar) {
                    break;
                }
            }
        }

        let totalQuantity = this._TicketList.GetQuantity();
        if (this.ShowPriceInCalendar && totalQuantity > 0) {
            for (let tmpDate of dateList) {
                let date = moment(tmpDate.Date, 'YYYY-MM-DD');
                this.ShowPriceInCalendar = true;
                let totalAmount: number = 0;

                for (let prod of this._TicketList.ProductList.filter(x => x.Quantity > 0)) {
                    let dateEntry = tmpDate.TariffList.find(x => x.SubProductIdentifier == prod.SubProductIdentifier);
                    totalAmount += (prod.Quantity * this._TicketList.GetPrice(dateEntry.Price));
                }
                let price = this._TicketList.GetPriceStringWithCurrencySymbol(totalAmount).replace(`${this.CultureInfo.currencyDecimalSeparator}00`, '');
                this.DatePicker.AddText(date, price);
                this.DatePickerMobile.AddText(date, price);
            }
            this.DatePicker.FillEmptyText();
            this.DatePickerMobile.FillEmptyText();
        } else if (totalQuantity <= 0) {
            this.DatePicker.RemoveAllText();
            this.DatePickerMobile.RemoveAllText();
        }
    }

    CheckPriceChangeOnDateChange(cell: Cell) {
        let dayPriceList = this.AvailableDateList.find(x => x.Date == cell.Date.format('YYYY-MM-DD'));
        let priceChange = false;
        if (dayPriceList != null) {
            for (let prod of this._TicketList.ProductList) {
                let cellTariff = dayPriceList.TariffList.find(x => x.SubProductIdentifier == prod.SubProductIdentifier);

                if (cellTariff != null && cellTariff.Price != prod.Price) {
                    priceChange = true;
                    prod.Price = cellTariff.Price;
                    prod.ForeignPrice = cellTariff.ForeignPrice;
                }
            }

            if (priceChange) {
                this._TicketList.AdjustTotalAmount(true);
            }
        }
    }

    CheckDate(x: Cell) {
        if (x != null) {
            this.ActivateDate = x.Date;
            let formatedDate = this.ActivateDate.format(this.DatePattern);
            this._TicketList.SetFromDate(x.Date);
            this.CheckPriceChangeOnDateChange(x);
            this.DateDropdown.setValue(formatedDate);
            $('.prod_selection__summary-date').html(formatedDate);
        } else {
            this.DateDropdown.resetSelection();
            this.ActivateDate = null;
        }
        this.CheckSubmit();
    }

    CheckSubmit(): boolean {
        if (this.ActivateDate != null) {
            $('.prod_selection__prod-save').removeAttr('disabled');

            if (this.ContingentMode) {
                let dayEntry = this.AvailableDateList.find(x => moment(x.Date, 'YYYY-MM-DD').isSame(this.ActivateDate));
                if (dayEntry != null) {
                    $('.prod_selection__prod-contingentCount').html(this._I18nHelper.GetTranslation(Translations.CountAvailable, dayEntry.Available));
                }
            }
        } else {
            $('.prod_selection__prod-contingentCount').html('');
            $('.prod_selection__prod-save').attr('disabled', 'disabled');
        }

        if (!$('.prod_selection__persontype-submit').hasClass('Loading')) {
            this.setSubmitButtonState();
        }
        return this.ActivateDate != null && this.QuantityOK;
    }

    setSubmitButtonState() {
        let checkMinMaxConstraintResult = new CheckMinMaxConstraintResult();

        let minMaxConstraintModule = AxLoad.GetModule<PackageMinMaxConstraint>('PackageMinMaxConstraint');

        if (minMaxConstraintModule != null) {
            checkMinMaxConstraintResult = minMaxConstraintModule.CheckMinMaxConstraint(this._TicketList.GetQuantity());
        } else {
            checkMinMaxConstraintResult.minMaxOk = true;
        }

        if (this.QuantityOK && this.ActivateDate != null && checkMinMaxConstraintResult.minMaxOk) {
            $('.prod_selection__persontype-submit').removeAttr('disabled');
            $('.prod_selection__summary').toggle(true);
            // OCD not to see neither the loader nor the Next word. Remove if OK!
            //$('.prod_selection__persontype-submit').html(this._I18nHelper.GetTranslation(Translations.Next));
        } else {
            $('.prod_selection__persontype-submit').attr('disabled', 'disabled');
            $('.prod_selection__summary').toggle(false);

            if (!checkMinMaxConstraintResult.minMaxOk) {
                $('.prod_selection__persontype-submit').html(checkMinMaxConstraintResult.errorMessage);
            } else {
                $('.prod_selection__persontype-submit').html(this._I18nHelper.GetTranslation(Translations.Next));
            }
        }
    }

    abstract ToSummary(): void;
}

export interface AxProdInitData extends InitData {
    StartOfWeek: number;
    Lang: string;
    StartDate: string;
    EndDate?: string;
    PostURL: string;
    DatePattern: string;
    DatePatternYear: string;
    CheckDateLink: string;
    DayRange: number;
    closedDays: string[];
}

interface DateList {
    Date: string,
    Contingent: boolean,
    Available: number;
    Max: number;
    TariffList: PriceList[];
}

interface PriceList {
    SubProductIdentifier: number; //PersonTypeNr, PackagePosNr
    Price: number;
    ForeignPrice: number;
}